// src/components/Toast.jsx
import React, { useEffect } from 'react';

export default function Toast({ message, type = 'success', onClose, duration = 3500 }) {
  useEffect(() => {
    const t = setTimeout(onClose, duration);
    return () => clearTimeout(t);
  }, [onClose, duration]);

  const icons = { success: '✓', error: '✕', info: 'ℹ' };
  const colors = {
    success: { border: 'rgba(76,175,125,0.4)', icon: 'var(--green)' },
    error: { border: 'rgba(212,83,83,0.4)', icon: 'var(--red)' },
    info: { border: 'var(--border-2)', icon: 'var(--gold)' },
  };

  return (
    <div className="toast" style={{ borderColor: colors[type]?.border }}>
      <div style={{
        width: 28, height: 28, borderRadius: '50%',
        background: `${colors[type]?.icon}20`,
        border: `1px solid ${colors[type]?.icon}40`,
        color: colors[type]?.icon,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 13, fontWeight: 600, flexShrink: 0,
      }}>{icons[type]}</div>
      <span style={{ fontSize: 13, lineHeight: 1.5, flex: 1 }}>{message}</span>
      <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-3)', cursor: 'pointer', fontSize: 18, lineHeight: 1, flexShrink: 0 }}>×</button>
    </div>
  );
}
